import React from "react";
import { ClipboardList } from "lucide-react";

function barColor(v) {
  if (v >= 8) return "#16A34A";
  if (v >= 6) return "#65A30D";
  if (v >= 4) return "#D97706";
  return "#DC2626";
}

export default function EncuestaCard({ summary, seccion }) {
  const enc = summary?.encuesta;

  return (
    <div data-testid="encuesta-card"
      className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm h-full">
      <div className="flex items-center gap-2 mb-4">
        <span className="w-8 h-8 rounded-lg bg-terracota-light text-terracota flex items-center justify-center">
          <ClipboardList className="w-4 h-4" />
        </span>
        <div>
          <h3 className="font-heading text-base font-bold text-slate-900 leading-tight">
            Calificaciones Ciudadanas
          </h3>
          <p className="text-[11px] text-slate-400">Encuestas por sección (escala 0-10)</p>
        </div>
      </div>

      {!seccion ? (
        <p className="text-sm text-slate-400 py-6 text-center">
          Selecciona una sección para ver las calificaciones ciudadanas.
        </p>
      ) : !enc || !enc.metrics?.length ? (
        <p className="text-sm text-slate-400 py-6 text-center">
          No hay datos de encuestas para la sección {seccion}.
        </p>
      ) : (
        <div className="space-y-3">
          {enc.metrics.map((m) => (
            <div key={m.key} data-testid={`encuesta-${m.key}`}>
              <div className="flex justify-between text-xs mb-1">
                <span className="text-slate-600 font-medium">{m.label}</span>
                <span className="font-bold text-slate-800">{m.value.toFixed(1)}</span>
              </div>
              <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
                <div className="h-full rounded-full transition-all"
                  style={{ width: `${(m.value / 10) * 100}%`, background: barColor(m.value) }} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
